const waitForRecaptcha = (maxAttempts = 20): Promise<void> =>
  new Promise((resolve, reject) => {
    let attempts = 0;
    const interval = setInterval(() => {
      if (window.grecaptcha && window.grecaptcha.ready) {
        clearInterval(interval);
        window.grecaptcha.ready(resolve);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        reject(new Error('reCAPTCHA no se cargó a tiempo.'));
      }
      // eslint-disable-next-line no-plusplus
      attempts++;
    }, 200);
  });

export default async function validateRecaptcha(
  token: string,
  action: string,
  waitForReadyRecaptcha: boolean,
) {
  if (waitForReadyRecaptcha) await waitForRecaptcha();
  return new Promise((res, rej) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(token, { action })
        .then((response: any) => res(response))
        .catch((error: any) => rej(error));
    });
  });
}
